import { useMemo } from "react";

import { Dropdown } from "../../../../common/Atoms/Dropdown";
import { useGetSelectedOrganisation } from "../../../hooks/useGetSelectedOrganisation";
import { useCurrentOrgUsers } from "../../../hooks/useCurrentOrgUsers";
import { useBulkAssignContactsMutation } from "../../../services/api/contactsApi/contact";

interface IBulkAssignContactProps {
  selectedContacts: number[];
}

const UNASSIGN = `__UNASSIGN__`;

export function BulkAssignContact({ selectedContacts }: IBulkAssignContactProps) {
  const currentOrg = useGetSelectedOrganisation();
  const currentOrgUsers = useCurrentOrgUsers(true);
  const [bulkAssign, { isLoading }] = useBulkAssignContactsMutation();

  const userOptions = useMemo(() => currentOrgUsers.map(u => ({
    value: u.value,
    label: u.label,
  })), [currentOrgUsers]);

  function handleSelect(e: { value: string; label: string }) {
    if (!currentOrg?.id) return;

    bulkAssign({
      organisationId: currentOrg.id,
      contactIds: selectedContacts,
      userId: e.value === UNASSIGN ? null : e.value,
    });
  }

  return (
    <Dropdown
      buttonColor={ `white` }
      options={ [
        [{ value: UNASSIGN, label: `Unassign` }],
        userOptions,
      ] }
      onSelect={ handleSelect }
      label={ `Assign contacts` }
      size={ `sm` }
      disabled={ !selectedContacts.length }
      loading={ isLoading }
      theme={ `outline` }
    />
  );
}
